import './Interview.scss';

import React, {Component} from 'react';
import {connect} from "react-redux";
import {toastr} from 'react-redux-toastr';
import {getFormValues, isDirty} from 'redux-form'
import {Collapse} from "reactstrap";
import { isEqual } from '../../../../../shared/services/lodashInJS.js';

import conf from "../../../../../shared/conf";
import localConf from "../../../../conf.js"
import api from "../../../../../api";
import withCurrentUniverse from "../../../../HOC/withCurrentUniverse.jsx";
import {Prompt} from "react-router-dom";

import {SUCCESS_STATUS} from "../../StrategyFreelanceContainer.jsx";

import {generate} from "../../../../routes.js";
import {isAdmin, isUserDo, isUserFreelance} from "../../../../../shared/services/userService";
import Loader from '../../../../../shared/components/Loader/Loader.jsx';

import FreelanceInterviewConfirmInfoForm, {
  name as FreelanceInterviewConfirmInfoFormName
} from "../../../../../shared/components/Forms/FreelanceInterview/FreelanceInterviewConfirmInfoForm.jsx";
import ConfirmInfoSubmitButton
  from "../../../../../shared/components/Forms/FreelanceInterview/ConfirmInfoSubmitButton.jsx";

import FreelanceInterviewSectorsForm, {
  name as FreelanceInterviewSectorsFormName
} from "../../../../../shared/components/Forms/FreelanceInterview/FreelanceInterviewSectorsForm.jsx";
import SectorsSubmitButton from "../../../../../shared/components/Forms/FreelanceInterview/SectorsSubmitButton.jsx";

import FreelanceInterviewSkillsForm, {
  name as FreelanceInterviewSkillsFormName
} from "../../../../../shared/components/Forms/FreelanceInterview/FreelanceInterviewSkillsForm.jsx";
import SkillsSubmitButton from "../../../../../shared/components/Forms/FreelanceInterview/SkillsSubmitButton.jsx";

import FreelanceInterviewAppreciationForm, {
  name as FreelanceInterviewAppreciationFormName
} from "../../../../../shared/components/Forms/FreelanceInterview/FreelanceInterviewAppreciationForm.jsx";
import AppreciationSubmitButton
  from "../../../../../shared/components/Forms/FreelanceInterview/AppreciationSubmitButton.jsx";

import FreelanceInterviewRemarkForm, {
  name as FreelanceInterviewRemarkFormName
} from "../../../../../shared/components/Forms/FreelanceInterview/FreelanceInterviewRemarkForm.jsx";
import RemarkSubmitButton from '../../../../../shared/components/Forms/FreelanceInterview/RemarkSubmitButton.jsx';

import ReviewLoaded from "../Review/Component/ReviewLoaded.jsx";
import UploadUserImageForm from "../../../../components/Forms/UploadUserImageForm/UploadUserImageForm.jsx";

import FormTitleRow from "../../../../../shared/components/Styled/Form/FormTitleRow.jsx";
import {
  CREATE_FREELANCE_STEPS,
  updateCreatFreelanceStep
} from "../../../../../shared/containers/Freelance/setNextStep.js";
import connectModal from "../../../../../shared/components/Modals/connect.js";

import ConfirmCloseInterviewModal
  from "../../../../../shared/components/Modals/FreelanceInterviewModal/ConfirmCloseInterviewModal.jsx";
import SkillsTreeButton from '../../../../../shared/components/Forms/FreelanceInterview/SkillsTreeButton.jsx';

const initialCollapsedState = {
  interview: true,
  sectors: false,
  skills: false,
  reviews: false,
  notes: false,
  appreciation: false,
  nextSteps: false,
  missions: false,
}

export class Interview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      edit: false,
      collapsed: initialCollapsedState,
      emptySectors: false,
      emptySkills: false,
      step: '',
      shouldUpdateReview: false
    };
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const { freelance: prevFreelance } = prevProps
    const { freelance } = this.props

    if (this.props.freelance && this.props.freelance.id !== prevProps.freelance.id) {
      this.setState({
        ...this.state,
        endReview: false,
        reviewId: null,
      });
      this.loadHumanSkills(this.props.freelance);
      return
    }

    if(prevFreelance && freelance && !isEqual(prevFreelance, freelance)) {
      this.loadHumanSkills(freelance);
    }

    if (this.state.shouldUpdateReview) {
      this.loadHumanSkills(freelance);
    }
  }

  componentDidMount() {
    this.loadHumanSkills(this.props.freelance);
    this.setState({user: this.props.user})
  }

  makeChildComponentKey = (prefix = '') => {
    return `${prefix}-${Date.now()}`
  }

  onSubmitAndRedirect = async () => {
    const response = await this.onSubmitForms(false, true)

    if(!response || !response.status) {
      return
    }

    updateCreatFreelanceStep(
      this.props.freelance.id,
      CREATE_FREELANCE_STEPS.PRESENTATION,
      () => {
        const {isAdmin, isUserDo, match, location, link: propsLink }  = this.props
        if ((isAdmin || isUserDo) && response.status === SUCCESS_STATUS) {
          const link = generate({
            name: `${propsLink && propsLink.menu ? propsLink.menu : 'search.view'}.monitor`,
            parameters: match.params,
            search: location.search
          })
          this.props.history.push(link)
        }
      }
    )
  }
  onSubmitAndCollapsed = async (collapsedKey) => {
    const response = await this.onSubmitForms(false)

    if(!response || !response.status) {
      return
    }
    this.toogleCollapsed(collapsedKey)
  }

  onConfirmCloseInterview = () => {
    this.props.openConfirmCloseInterviewModal({
      confirmCloseInterview: () => {
        this.setState({step: 'finish'}, () => this.onSubmitAndRedirect())
      }
    });
  }

  onSubmitForms = (shouldStopRefresh = false, interviewProcessFinished=false) => {
    const {
      freelanceInterviewConfirmInfoFormValues,
      freelanceInterviewSectorsFormValues,
      freelanceInterviewSkillsFormValues,
      freelanceInterviewAppreciationFormValues,
      freelanceInterviewRemarkFormValues
    } = this.props.forms

    let newUserData = {
      linkedin_url: freelanceInterviewConfirmInfoFormValues.user.linkedin_url,
      city: freelanceInterviewConfirmInfoFormValues.user.city,
      workCities: (freelanceInterviewConfirmInfoFormValues.user && freelanceInterviewConfirmInfoFormValues.user.work_cities)
        ? freelanceInterviewConfirmInfoFormValues.user.work_cities.map(city => {return city.id})
        : []
    }

    // Auto add in work cities selected user living city
    if(newUserData.city && newUserData.city[0]){
      const cityId = newUserData.city[0].id
      if(!newUserData.workCities.includes(cityId)) {
        const workCities = newUserData.workCities
        workCities.push(cityId)
        newUserData = {
          ...newUserData,
          workCities: workCities
        }
      }
    }

    const newFreelanceData = {
      // Confirmer informations
      agent: this.props.freelance.agent ? this.props.freelance.agent.id : null,
      date_available: freelanceInterviewConfirmInfoFormValues.freelance.date_available,
      date_available_tunnel_comment: freelanceInterviewConfirmInfoFormValues.freelance.date_available_tunnel_comment,
      price: freelanceInterviewConfirmInfoFormValues.freelance.price,
      relocation_long_fulltime: freelanceInterviewConfirmInfoFormValues.freelance.relocation_long_fulltime,
      relocation_long_fulltime_comment: freelanceInterviewConfirmInfoFormValues.freelance.relocation_long_fulltime_comment,
      situation: freelanceInterviewConfirmInfoFormValues.freelance.situation,
      work_permit: freelanceInterviewConfirmInfoFormValues.freelance.work_permit,
      yearly_brut: freelanceInterviewConfirmInfoFormValues.freelance.yearly_brut,

      // Secteurs
      secteurs: freelanceInterviewSectorsFormValues.freelance.secteurs,

      // Compétences et spécialités
      expertises: freelanceInterviewSkillsFormValues.freelance.expertises,
      fonctions: freelanceInterviewSkillsFormValues.freelance.fonctions,
      title: freelanceInterviewSkillsFormValues.freelance.title,
      master_skills: freelanceInterviewSkillsFormValues.freelance.master_skills,

      // Remarques
      interview_remark: freelanceInterviewRemarkFormValues.freelance.interview_remark,
      agent_remark: freelanceInterviewAppreciationFormValues.freelance.agent_remark,
      interview_process_finished: interviewProcessFinished,
    }

    // Check if secteurs and skills are selected
    const selectedSecteurs = this.prepareFreelance(newFreelanceData).secteurs
    const selectedSkills = [...freelanceInterviewSkillsFormValues.freelance.master_skills, ...freelanceInterviewSkillsFormValues.freelance.expertises]

    this.setState({emptySectors: false, emptySkills: false})

    if (this.state.step === "sectors" || this.state.step === "finish") {
      if (!selectedSecteurs.length) {
        !this.state.collapsed["sectors"] && this.toogleCollapsed("sectors")
        this.setState({emptySectors: true})
        toastr.error("Veuillez renseigner minimum un secteur pour valider le formulaire.")

        if (this.state.step === "sectors") {
          return
        }
      }
    }

    if (this.state.step === "skills" || this.state.step === "finish") {
      if (!selectedSkills.length) {
        setTimeout(() => !this.state.collapsed["skills"] && this.toogleCollapsed("skills"), 100)
        this.setState({emptySkills: true})
        toastr.error("Veuillez renseigner minimum une compétence pour valider le formulaire.")

        if (this.state.step === "skills") {
          return
        }
      }
    }

    if (this.state.step === "finish") {
      if (!selectedSecteurs.length || !selectedSkills.length) {
        return
      }
    }

    return this.props.submit({
      user: newUserData,
      freelance: this.prepareFreelance(newFreelanceData),
      shouldStopRefresh: shouldStopRefresh,
      submitInterview: true,
    }).then((response) => {
      return response
    })
  }

  prepareFreelance = (freelance) => {
    return {
      ...freelance,
      secteurs: freelance.secteurs.reduce((acc, secteur) => {
        if (secteur.checked === true) {
          acc.push(secteur);
        }
        return acc;
      }, []),
      agent: freelance.agent ? freelance.agent.id : null
    }
  };

  expandSecteurs = (freelance) => {
    const selectedSecteursIds = freelance.secteurs.map(secteur => secteur.id);

    return this.props.secteurs.reduce((acc, secteur) => {
      secteur.checked = selectedSecteursIds.includes(secteur.id);
      acc.push(secteur);
      return acc;
    }, []);
  };

  toogleCollapsed = (key) => {
    const isCollapsed = !this.state.collapsed[key]
    this.setState({collapsed: {...this.state.collapsed, [key]: isCollapsed}})
  }

  // Reviews
  loadHumanSkills = async (freelance) => {
    try {
      const humanSkills = this.props.humanSkills.filter(skill => skill.account_type === conf.accountTypes.do);
      this.setState({
        humanSkills: this.lightenSkills(humanSkills),
        skills: this.lightenSkills(freelance.master_skills)
      });

      this.loadFreelanceReview(freelance);
    } catch (e) {
      console.warn(e);
      this.setState({humanSkills: []});
    } finally {
      this.setState({shouldUpdateReview: false})
    }
  };

  lightenSkills = (skills) => {
    return skills.map(skill => ({
      id: skill.id,
      name: skill.name,
    }));
  }

  loadFreelanceReview = async (freelance) => {
    try {
      const reviewResponse = await api.freelances.reviews.getAll({
        freelance: freelance.id,
      });

      if (reviewResponse.data.reviews.length === 0) {
        console.warn('empty review response data')
        return;
      }

      const {human_skills = [], skills = [], id, global_rating} = reviewResponse.data.reviews[0];

      this.setState({
        globalRating: global_rating,
        humanSkills: this.mergeSkillsWithReviewSkills(this.state.humanSkills, human_skills),
        reviewId: id,
        skills: this.mergeSkillsWithReviewSkills(this.state.skills, skills),
      });
    } catch (e) {
      console.warn(e);
      this.setState({
        reviewId: null
      });
    } finally {
      this.setState({
        endReview: true,
      })
    }
  };

  mergeSkillsWithReviewSkills = (skills, reviewSkills) => {
    skills.forEach((skill) => {
      reviewSkills.forEach((reviewSkill) => {
        if (reviewSkill.skill && skill.id === reviewSkill.skill.id) {
          skill.rate = reviewSkill.rate;
        }
      });
    });

    return skills;
  }
  setReviewId = (reviewId) => {
    this.setState({reviewId});
  }
  isDirty = () => this.props.forms.isFreelanceInterviewConfirmInfoFormDirty
    || this.props.forms.isFreelanceInterviewSectorsFormDirty
    || this.props.forms.isfreelanceInterviewSkillsFormValues
    || this.props.forms.isfreelanceInterviewAppreciationFormValues
    || this.props.forms.isfreelanceInterviewRemarkFormValues

  onUploadSuccess = (image) => {
    this.setState({
      user: {
        ...this.props.user,
        image,
      }})
  };

  render() {
    const {
      globalRating,
      humanSkills,
      reviewId,
      skills
    } = this.state

    return (
      <div>
        <Prompt when={this.isDirty()}
          message="Des modifications sont en cours êtes vous sûre de vouloir quitter sans sauvegarder ?"/>

        <Loader visible={!!this.state.loading}>Sauvegarde</Loader>
        <div className="step-interview bg-white bd-gray-200 p-5">
          <h2 className="text-center">Formulaire d'entretien</h2>
          {/*Confirm Information*/}
          <div className="row align-items-center">
            <div className="col">
              <FormTitleRow chip={1} text={'Confirmer informations'}/>
            </div>
            <div className="col-1">
              <button type="button" className="btn btn-link" onClick={() => this.toogleCollapsed('interview')}>
                {this.state.collapsed.interview ? `-` : `+`}
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Collapse isOpen={this.state.collapsed.interview}>
                <FreelanceInterviewConfirmInfoForm
                  localConf={localConf}
                  onSubmit={() => this.onSubmitAndCollapsed('interview')}
                  initialValues={{
                    user: this.props.user,
                    freelance: this.props.freelance,
                  }}
                  user={this.props.user}
                  uploadUserImageForm={this.state.user &&
                      <UploadUserImageForm
                        image={this.state.user.image}
                        userId={this.state.user.id}
                        hideText={true}
                        onUploadSuccess={this.onUploadSuccess}>
                      </UploadUserImageForm>
                  }
                  onUploadSuccess={this.onUploadSuccess}
                  enableReinitialize={true}
                />
                <div className="mt-5 d-flex justify-content-end">
                  <ConfirmInfoSubmitButton className="btn btn-primary">Valider l'étape</ConfirmInfoSubmitButton>
                </div>
              </Collapse>
            </div>
          </div>

          {/* Sectors */}
          <div className="row align-items-center">
            <div className="col">
              <FormTitleRow chip={2} text={'Secteurs'}/>
            </div>
            <div className="col-1">
              <button type="button" className="btn btn-link" onClick={() => this.toogleCollapsed('sectors')}>
                {this.state.collapsed.sectors ? `-` : `+`}
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Collapse isOpen={this.state.collapsed.sectors}>
                <div className={`row ${this.state.emptySectors ? 'has-form-error' : ''}`}>
                  <div className="col-md-12">
                    <FreelanceInterviewSectorsForm
                      onSubmit={() => this.onSubmitAndCollapsed('sectors')}
                      enableReinitialize={true}
                      initialValues={{
                        user: this.props.user,
                        freelance: {...this.props.freelance, secteurs: this.expandSecteurs(this.props.freelance)}
                      }}
                    />
                  </div>
                </div>
                <div className="mt-5 d-flex justify-content-end">
                  <SectorsSubmitButton className="btn btn-primary" onClick={() => this.setState({step: 'sectors'})}>Valider l'étape</SectorsSubmitButton>
                </div>
              </Collapse>
            </div>
          </div>

          {/* Skills */}
          <div className="row align-items-center">
            <div className="col">
              <FormTitleRow chip={3} text={'Compétences et spécialités'}/>
            </div>
            <div className="col-1">
              <button type="button" className="btn btn-link" onClick={() => this.toogleCollapsed('skills')}>
                {this.state.collapsed.skills ? `-` : `+`}
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Collapse isOpen={this.state.collapsed.skills}>
                <div className={`row ${this.state.emptySkills ? 'has-form-error' : ''}`}>
                  <div className="col-md-12">
                    <FreelanceInterviewSkillsForm
                      onSubmit={() => this.onSubmitAndCollapsed('skills')}
                      enableReinitialize={true}
                      initialValues={{
                        user: this.props.user,
                        freelance: {...this.props.freelance, secteurs: this.expandSecteurs(this.props.freelance)}
                      }}
                    />
                  </div>
                </div>
                <div className="my-5 d-flex justify-content-between">
                  <SkillsTreeButton />
                  <SkillsSubmitButton className="btn btn-primary" onClick={() => this.setState({step: 'skills'})}>Valider l'étape</SkillsSubmitButton>
                </div>
              </Collapse>
            </div>
          </div>

          {/* Reviews */}
          <div className="row align-items-center">
            <div className="col">
              <FormTitleRow className={'mb-0'} chip={4} text={'Notations'}/>
            </div>
            <div className="col-1">
              <button type="button" className="btn btn-link" onClick={() => this.toogleCollapsed('reviews')}>
                {this.state.collapsed.reviews ? `-` : `+`}
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Collapse isOpen={this.state.collapsed.reviews}>
                {this.state.endReview ?
                  <ReviewLoaded
                    key={this.makeChildComponentKey('review_loaded')}
                    freelanceId={this.props.freelance.id}
                    globalRating={globalRating}
                    humanSkills={humanSkills}
                    reviewId={reviewId}
                    setReviewId={this.setReviewId}
                    skills={skills}
                    updateReviews={() => {this.setState({shouldUpdateReview: true})}}
                  /> : null}
              </Collapse>
            </div>
          </div>

          {/* Notes */}
          <div className="row align-items-center">
            <div className="col">
              <FormTitleRow chip={5} text={'Notes et remarques'}/>

            </div>
            <div className="col-1">
              <button type="button" className="btn btn-link" onClick={() => this.toogleCollapsed('notes')}>
                {this.state.collapsed.notes ? `-` : `+`}
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Collapse isOpen={this.state.collapsed.notes}>
                <FreelanceInterviewRemarkForm
                  enableReinitialize={true}
                  onSubmit={() => this.onSubmitAndCollapsed('notes')}
                  initialValues={{
                    user: this.props.user,
                    freelance: this.props.freelance
                  }}
                />
                <div className="mt-5 d-flex justify-content-end">
                  <RemarkSubmitButton className="btn btn-primary">Valider l'étape</RemarkSubmitButton>
                </div>
              </Collapse>
            </div>
          </div>

          {/* Appreciation */}
          <div className="row align-items-center">
            <div className="col">
              <FormTitleRow chip={6} text={'Appréciation de l\'agent'}/>
            </div>
            <div className="col-1">
              <button type="button" className="btn btn-link" onClick={() => this.toogleCollapsed('appreciation')}>
                {this.state.collapsed.appreciation ? `-` : `+`}
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Collapse isOpen={this.state.collapsed.appreciation}>
                <FreelanceInterviewAppreciationForm
                  onSubmit={() => this.onSubmitAndCollapsed('agent_remark')}
                  enableReinitialize={true}
                  initialValues={{
                    user: this.props.user,
                    freelance: this.props.freelance
                  }}
                />
                <div className="mt-5 d-flex justify-content-end">
                  <AppreciationSubmitButton className="btn btn-primary">Valider l'étape</AppreciationSubmitButton>
                </div>
              </Collapse>
            </div>
          </div>

          {/* Next Steps */}
          <div className="row align-items-center">
            <div className="col">
              <FormTitleRow chip={7} text={'Parler des prochaines étapes'}/>
            </div>
            <div className="col-1">
              <button type="button" className="btn btn-link" onClick={() => this.toogleCollapsed('nextSteps')}>
                {this.state.collapsed.nextSteps ? `-` : `+`}
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Collapse isOpen={this.state.collapsed.nextSteps}>
                <ul>
                  <li>Envoyer une photo correcte si ce n'est pas le cas</li>
                  <li>Il faut se reconnecter à son profil pour compléter ses missions</li>
                  <li>Renseigner les missions dans un temps raisonnable pour que le profil soit publié</li>
                  <li>Une fois le profil publié, il/elle pourra avoir accès à nos missions</li>
                </ul>
              </Collapse>
            </div>
          </div>

          {/* Mission */}
          <div className="row align-items-center">
            <div className="col">
              <FormTitleRow chip={8} text={'Pédagogie sur le nombre de missions publiées'}/>
            </div>
            <div className="col-1">
              <button type="button" className="btn btn-link" onClick={() => this.toogleCollapsed('missions')}>
                {this.state.collapsed.missions ? `-` : `+`}
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Collapse isOpen={this.state.collapsed.missions}>
                <ul>
                  <li>On ne publie pas toutes les missions</li>
                  <li>Ils ont le choix de recevoir par mail et/ou SMS</li>
                  <li>Ils peuvent stopper et réactiver les SMS</li>
                  <li>Si profil masqué, ils n'auront plus de notifs</li>
                </ul>
              </Collapse>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="mt-5 d-flex justify-content-end">
                <button className="btn btn-primary"
                  type={'button'}
                  onClick={this.onConfirmCloseInterview}>
                    Valider le formulaire
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connectModal(
  {ConfirmCloseInterviewModal},
  connect(
    state => ({
      isAdmin: isAdmin(state.currentUser.user),
      isUserDo: isUserDo(state.currentUser.user),
      isUserFreelance: isUserFreelance(state.currentUser.user),
      forms: {
        freelanceInterviewConfirmInfoFormValues: getFormValues(FreelanceInterviewConfirmInfoFormName)(state),
        isFreelanceInterviewConfirmInfoFormDirty: isDirty(FreelanceInterviewConfirmInfoFormName)(state),
        freelanceInterviewSectorsFormValues: getFormValues(FreelanceInterviewSectorsFormName)(state),
        isFreelanceInterviewSectorsFormDirty: isDirty(FreelanceInterviewSectorsFormName)(state),
        freelanceInterviewSkillsFormValues: getFormValues(FreelanceInterviewSkillsFormName)(state),
        isfreelanceInterviewSkillsFormValues: isDirty(FreelanceInterviewSkillsFormName)(state),
        freelanceInterviewAppreciationFormValues: getFormValues(FreelanceInterviewAppreciationFormName)(state),
        isfreelanceInterviewAppreciationFormValues: isDirty(FreelanceInterviewAppreciationFormName)(state),
        freelanceInterviewRemarkFormValues: getFormValues(FreelanceInterviewRemarkFormName)(state),
        isfreelanceInterviewRemarkFormValues: isDirty(FreelanceInterviewRemarkFormName)(state),
      },
      secteurs: state.secteurs.secteurs,
      humanSkills: state.universe?.currentUniverse.human_skills?.length ? state.universe.currentUniverse.human_skills : []
    })
  )(withCurrentUniverse(Interview)));
